<template>
    <Modal :title="title" v-model="show" :closable="false" :mask-closable="false">
        <el-alert >{{tips}}</el-alert>
        <el-form ref="moneyChange" label-position="right" label-width="80px" :model="moneyChange" :rules="moneyRules">
            <el-input type="hidden" :model="moneyChange.id" />
            <el-form-item label="数量" prop="count">
                <el-input  size="small" v-model="moneyChange.count" type="number" placeholder="数量" style="width: 240px" />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input  size="small" type="textarea" v-model="moneyChange.remark" placeholder="备注" style="width: 240px" />
            </el-form-item>
       </el-form>
        <div slot="footer">
            <el-button  size="small" @click="cancel">取消</el-button>
            <el-button  size="small" type="primary" :loading="modalMoneyLoading" @click="ok">确定</el-button>
        </div>
    </Modal>
    </Modal>
</template>
<script>
export default {
    name: 'CStorageProduct',
    data() {
        return {

            modalMoneyLoading: false,
            moneyChange: {
                type: 1,
                count: 0,
                remark: "",

            },
            moneyRules: {
                count: [{
                    required: true,
                    message: "数量不能为空,或格式不对",
                }],
                remark: [{
                    required: true,
                    message: "备注不能为空",
                }]
            },

        };
    },
    props: [
        'productId', 'show', 'title', 'type'
    ],
    mounted: function() {


    },
    computed: {
        tips: function() {
            return "当前操作：" + this.title;
        }
    },
    methods: {
        ok: function() {
 var me = this;
            this.$refs['moneyChange'].validate((valid) => {

                if (valid) {
                    if (this.moneyChange.count <= 0) {
                        this.$message.error('请认真填写数量');
                    }
                   
                    var url = "/ware/product/sub.action";
                    if (me.type == 2)
                        url = "/ware/product/add.action";
                    me.moneyChange.productId = me.productId;
                    me.moneyChange.type=me.type;
                    me.modalMoneyLoading = true;
                    me.$http.post(url, me.moneyChange).then(response => {
                        var body = response;
                        if (body.status == 0) {

                            me.$message.info("操作成功");
                            me.moneyChange = {};
                            me.$emit('ok');

                        } else {
                            me.$message.error("操作异常!" + body.info);
                        }
                        me.modalMoneyLoading = false;
                    }, response => {
                        me.modalMoneyLoading = false;
                    });
                } else {
                    this.$message.error('请认真填写数据');
                }
            });


        },
        cancel: function() {
            this.moneyChange = {};
            this.$emit('cancel');
        }
    }
}
</script>